import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { CommunicationPartial } from './communication-partial.model';
import { CommunicationService } from './communication.service';

@Injectable()
export class CommunicationPartialResolver implements Resolve<CommunicationPartial> {
  constructor(private communicationService: CommunicationService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CommunicationPartial> {
    return this.communicationService.partial(route.paramMap.get('partialId'));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/communications/communication-partial.resolver.ts